import React from 'react'

function GeolocationIcon({ className, ...props }) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <circle
                cx="12"
                cy="9.66506"
                r="2.751"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0005 3.41406C14.5982 3.41417 17.2345 4.93682 18.0044 7.61621C18.774 10.2951 17.781 14.4951 12.271 20.0234C12.1248 20.17 11.8763 20.1698 11.73 20.0234C6.21984 14.4951 5.22602 10.2951 5.99561 7.61621C6.76557 4.93671 9.40266 3.41406 12.0005 3.41406Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default GeolocationIcon
